export default __webpack_public_path__ + "static/media/Blog6.80afb4a8.png";